export function flipCardImage(event){
    const container = event.target.closest('.sketch-image-container');
    if(!container){
        return;
    }
    if (container.classList.contains("no-back")){
        return;
    }
    container.querySelector('.sketch-image-flipper').classList.toggle('flipped');
}